

export class CountryUpdateInput implements ICountryUpdateInput {
    /** The auto-generated id of the country master */
    countryId!: number;
    /** The country name with 255 character limit */
    countryName!: string;

    constructor(data?: ICountryUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): CountryUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CountryUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data; 
    }
}

export interface ICountryUpdateInput {
    /** The auto-generated id of the country master */
    countryId: number;
    /** The country name with 255 character limit */
    countryName: string;
}

